<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Send Payment'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Do you want to pay a pending bill or send payment for a new job?'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [header]="'Send Payment for New Job'" />
      </tidy-row>
      @if (pendingInvoices?.length) {
        <tidy-alert>
          <tidy-text
            [body]="'Please pay all outstanding bills before sending payment for a new job.'" />
        </tidy-alert>
      }
      @if (!pendingInvoices?.length) {
        <tidy-card>
          <tidy-card-button (action)="goToSendPayment()">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/salary.svg'"
                [class]="body-size" />
              <tidy-text
                [body]="'New Job'" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
      <tidy-row>
        <tidy-text
          [header]="'Send Payment for Pending Bills'" />
      </tidy-row>
      @for (invoice of pendingInvoices; track invoice) {
        <tidy-card>
          <tidy-card-button (action)="goToInvoice(invoice)">
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/alert.svg'"
                [class]="body-size" />
              <tidy-text
                [body]="invoice?.amount | tcurrency" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'total for'" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="invoice?.items[0]?.service_details?.date | parseDateTime: 'MMM d'" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="'job'" />
                  </tidy-row>
                </tidy-card-button>
              </tidy-card>
            }
            @if (pendingInvoices?.length >= 10) {
              <tidy-card>
                <tidy-card-button (action)="goToBillsPage()">
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/alert.svg'"
                      [class]="body-size" />
                    <tidy-text
                      body="View More" />
                  </tidy-row>
                </tidy-card-button>
              </tidy-card>
            }
          }
        </tidy-wrapper>
      </ng-template>

      @if (!isRightSideContent) {
        <app-scroll-wrapper [templateContent]="content" />
      }

      @if (isRightSideContent) {
        <ion-content class="ion-content-right-column">
          <ng-container *ngTemplateOutlet="content" />
        </ion-content>
      }
